"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaDadosDispositivo = exports.yupDadosDispositivo = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupDadosDispositivo = yup.object({
    userId: yup.string().default('').required().label('User ID'),
    pushToken: yup.string().default('').required().label('Push Token'),
    tipoUsuario: yup
        .mixed()
        .oneOf(Object.values(enums_1.EUserType))
        .required()
        .default(enums_1.EUserType.Aluno)
        .label('Tipo usuário'),
    idAluno: yup.number().default(null).nullable().notRequired().label('Aluno'),
    idCliente: yup.number().default(null).nullable().notRequired().label('Responsável'),
    idProfessor: yup.number().default(null).nullable().notRequired().label('Professor'),
    idLoginExtra: yup.number().default(null).nullable().notRequired().label('Login Extra do aluno'),
    idUsuario: yup.number().default(null).nullable().notRequired().label('Usuário'),
    app: yup.mixed().oneOf(Object.values(enums_1.EAppType)).required().default(enums_1.EAppType.Push).label('Tipo de App'),
    notTodas: yup.boolean().required().default(true).label('Receber notificações'),
    notAgenda: yup.boolean().notRequired().nullable().default(true).label('Notificações de agenda'),
    notAviso: yup.boolean().notRequired().nullable().default(true).label('Notificações de avisos'),
    notBiblioteca: yup.boolean().notRequired().nullable().default(true).label('Notificações de biblioteca'),
    notBoletim: yup.boolean().notRequired().nullable().default(true).label('Notificações de notas de boletim'),
    notCatraca: yup.boolean().notRequired().nullable().default(true).label('Notificações de catraca'),
    notConteudo: yup.boolean().notRequired().nullable().default(true).label('Notificações de conteúdo ministrado'),
    notDocNEntre: yup.boolean().notRequired().nullable().default(true).label('Notificações de documentos pendentes'),
    notDocumento: yup.boolean().notRequired().nullable().default(true).label('Notificações de documentos'),
    notFinanceiro: yup.boolean().notRequired().nullable().default(true).label('Notificações de financeiro'),
    notHorario: yup.boolean().notRequired().nullable().default(true).label('Notificações de horários'),
    notMaterial: yup.boolean().notRequired().nullable().default(true).label('Notificações de materiais'),
    notOcorrencia: yup.boolean().notRequired().nullable().default(true).label('Notificações de ocorrências'),
    notProva: yup.boolean().notRequired().nullable().default(true).label('Notificações de notas de avaliações'),
    notRematricula: yup.boolean().notRequired().nullable().default(true).label('Notificações de rematrícula'),
    notChat: yup.boolean().notRequired().nullable().default(true).label('Notificações de chat'),
});
exports.schemaDadosDispositivo = exports.yupDadosDispositivo.shape({});
